// types.js
const FETCH_STATUS = 'status/all/fetch';
const FETCH_STATUS_SUCCESS = 'status/all/fetch-success';
const FETCH_STATUS_FAIL = 'status/all/fetch-fail';

export default {
  FETCH_STATUS,
  FETCH_STATUS_SUCCESS,
  FETCH_STATUS_FAIL,
}